<template>
  <v-tooltip top color="#311B92">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item :key="hObject.name" v-bind="attrs" v-on="on">
        <v-list-item-icon>
          <v-icon medium>mdi-office-building-marker-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="hObject.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <span v-text="hObject.name"></span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

export default {
  name: 'hObjectComponent',
  components: {},
  data() {
    return {}
  },
  props: {
    hObject: {
      required: true,
      type: Object,
      default: {
        name: ''
      }
    }
  },
  methods: {}
}
</script>

<style scoped>
.v-icon {
  color: #ede7f6;
}

.v-list-item__title {
  color: #ede7f6;
}

.v-list-item:hover {
  background-color: #4527a0;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HObject/HObject.vue